module.exports = __webpack_public_path__ + "img/big1.1166640a.png";